import { getDateRange } from '@modules/common/components/DateRangePicker/helpers/getDateRange';
import { getDateTimeRange } from '@modules/common/components/DateRangePicker/helpers/getTimeRange';
import {
  DateTimeRange,
  FixedDateTimeRange,
} from '@modules/common/components/DateRangePicker/types';

export const getFixedDateTimeRangeFromDateTimeRange = (
  dateRange: DateTimeRange,
): FixedDateTimeRange => {
  if (dateRange.type === 'absolute') {
    return dateRange;
  }

  const dayjsDateRange = getDateRange(dateRange);

  return getDateTimeRange(dayjsDateRange, 'absolute') as FixedDateTimeRange;
};
